import axios from '../utils/AxiosInstance'

export default {
  // namespaced: true,
  state: {
    questionforms: {
      selectIds: [],
      filters: {},
      paginate: {},
      selectId: false
    }
  },
  mutations: {
    SET_QUESTIONFORM_SELECT_IDS (store, ids) {
      store.questionforms.selectIds = ids
    },
    REMOVE_QUESTIONFORM_SELECT_IDS (store, ids) {
      store.questionforms.selectIds = store.questionforms.selectIds.filter((v) => { return !ids.includes(v) })
    },
    SET_QUESTIONFORM_SELECT_ID (store, id) {
      store.questionforms.selectId = id
    },
    SET_QUESTIONFORM_FILTERS (store, filters) {
      store.questionforms.filters = filters
    },
    SET_QUESTIONFORM_PAGINATE (store, val) {
      store.questionforms.paginate = {
        limit: val.limit,
        page: val.page,
        pages: val.pages,
        total: val.total
      }
    }
  },
  getters: {
    getQuestionforms: (store, getters) => {
      return store.questionforms.selectIds.map((id) => {
        return getters['entities/questionforms/find'](id)
      })
    },
    getQuestionformsFilters: (store, getters) => {
      return store.questionforms.filters
    },
    getQuestionformsPaginate: (store, getters) => {
      return store.questionforms.paginate
    },
    getQuestionform: (store, getters) => {
      return getters['entities/questionforms/find'](store.questionforms.selectId) || {}
    }
  },
  actions: {
    /*
    selectQuestionforms
    */
    selectQuestionforms ({commit, dispatch, getters, state}, filters) {
      return dispatch('getQuestionforms', filters)
      .then((response) => {
        commit('SET_QUESTIONFORM_FILTERS', filters)
        commit('SET_QUESTIONFORM_PAGINATE', response)
        commit('SET_QUESTIONFORM_SELECT_IDS', response.docs.map((item) => { return item._id }))
        return response
      })
    },
    /*
    refreshSelectQuestionforms
    */
    refreshSelectQuestionforms ({commit, dispatch, getters, state}) {
      return dispatch('selectQuestionforms', getters.getQuestionformsFilters)
    },
    /*
    selectQuestionform
    */
    selectQuestionform ({commit, dispatch, getters, state}, id) {
      return dispatch('getQuestionformById', id)
      .then((response) => {
        commit('SET_QUESTIONFORM_SELECT_ID', response._id)
        return response
      })
    },
    /*
    getQuestionforms
    */
    getQuestionforms ({commit, dispatch, getters, state}, filters) {
      return axios
      .get(`/accounts/${getters.getAccount._id}/questionforms`, {params: filters})
      .then((response) => {
        return dispatch('entities/questionforms/insert', {
          data: response.data.docs
        })
        .then((result) => {
          return {
            docs: result.questionforms || [],
            limit: response.data.limit,
            page: response.data.page,
            pages: response.data.pages,
            total: response.data.total
          }
        })
      })
    },
    /*
    getQuestionformById
    */
    getQuestionformById ({commit, dispatch, getters, state}, id) {
      return axios
      .get(`/accounts/${getters.getAccount._id}/questionforms/${id}`)
      .then((response) => {
        return dispatch('entities/questionforms/insert', {
          data: response.data
        })
      })
      .then((result) => {
        return result.questionforms[0]
      })
    },
    /*
    createQuestionform
    */
    createQuestionform ({commit, dispatch, getters, state}, data) {
      delete data.$id

      return axios
      .post(`/accounts/${getters.getAccount._id}/questionforms`, data)
      .then((response) => {
        return dispatch('entities/questionforms/insert', {
          data: response.data
        })
      })
      .then((response) => {
        return response.questionforms[0]
      })
    },
    /*
    updateQuestionform
    */
    updateQuestionform ({commit, dispatch, getters, state}, data) {
      delete data.$id

      return axios
      .put(`/accounts/${getters.getAccount._id}/questionforms/${data._id}`, data)
      .then((response) => {
        return dispatch('entities/questionforms/insert', {
          data: response.data
        })
      })
      .then((response) => {
        return response.questionforms[0]
      })
    },
    /*
    deleteQuestionform
    */
    deleteQuestionform ({commit, dispatch, getters, state}, id) {
      return axios
      .delete(`/accounts/${getters.getAccount._id}/questionforms/${id}`)
      .then((response) => {
        commit('REMOVE_QUESTIONFORM_SELECT_IDS', [id])
        dispatch('entities/questionforms/delete', id)
        return {}
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/Questionform.js